import { DriveHeroNewProduct, DriveHeroSlide } from '@interfaces/Drivetypes'

export const DRIVE_HERO_ANIMATION_TIMEOUT = 500
export const MOBILE_SWIPE_THRESHOLD = 40

export const createSlides = (rawProducts: DriveHeroNewProduct[] = []): DriveHeroSlide[] => {
  const totalItems = Math.max(3, rawProducts.length)

  return Array.from({ length: totalItems }, (_, i) => {
    const product = rawProducts[i % rawProducts.length]
    const carImage = product?.carImage
    const imageUrl = !carImage ? null : 'url' in carImage ? carImage.url : (carImage.data?.url ?? null)

    return {
      id: i,
      image: {
        url: imageUrl,
        alt: product?.carName || 'Car Image',
      },
      product: product
        ? {
            carName: product.carName,
            carPrice: product.carPrice,
            carSave: product.carSave,
            carOldPrice: product.carOldPrice,
          }
        : undefined,
    }
  })
}

export const getSlideClassName = (
  index: number,
  currentIndex: number,
  slidesLength: number,
  styles: Record<string, string>
) => {
  if (index === currentIndex) return styles.slideActive
  const prevIndex = (currentIndex - 1 + slidesLength) % slidesLength
  if (index === prevIndex) return styles.slidePrev
  const nextIndex = (currentIndex + 1) % slidesLength
  if (index === nextIndex) return styles.slideNext
  return styles.slideHidden
}
